import { type LinkOptions, type ParsedLocation } from '@tanstack/react-router'
import { atom } from 'jotai'

import { store } from './store'

/**
 * route path -> search params
 *
 * Used to restore search params when navigating back to a page.
 */
export const pageSearchAtom = atom<Record<string, LinkOptions>>({})

export const storePageSearch = (
  routePath: string,
  linkOptions: LinkOptions,
  location: ParsedLocation,
  cause: 'preload' | 'enter' | 'stay',
) => {
  if (cause === 'preload') return
  if (location.pathname !== routePath) return

  store.set(pageSearchAtom, (prev) => ({
    ...prev,
    [routePath]: linkOptions,
  }))
}
